// extracted by mini-css-extract-plugin
export var container = "Roof-module--container--927f5";
export var core = "Roof-module--core--53ceb";
export var slide = "Roof-module--slide--63c64";
export var slider = "Roof-module--slider--cbfc0";
export var text = "Roof-module--text--62841";